import React, { useEffect, useState } from "react";
import styles from "./Login.module.scss";
import TextForm, { TextFormResult } from "../../atoms/text-form/TextForm";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import { login } from "../../api/LoginApi";
import { useNavigate } from "react-router-dom";
import Header from "../../molecules/header/Header";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import iconOpenEye from "../../static/images/iconOpenEye.svg";
import iconCloseEye from "../../static/images/iconCloseEye.svg";
import lineIcon from "../../static/images/common/line_icon.png";

type Form = {
  email: string;
  password: string;
};

const Login = () => {
  const navigator = useNavigate();
  const [formValue, setFormValue] = useState<Form>({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  // ログインボタンの活性化判定
  const canLogin =
    formValue.email.trim().length > 0 &&
    formValue.password.trim().length > 0;

  const loginApi = login();
  const handleInputChange = (args: TextFormResult) => {
    setFormValue((prevValues) => ({ ...prevValues, [args.name]: args.value }));
  };

  const onLonginClick = () => {
    if (!canLogin) return;
    loginApi.post({
      email: formValue.email,
      password: formValue.password,
    });
  };
  
  const onLineLonginClick = () => {
    // LINEログインへリダイレクト(LineLoginApi にGETリクエストを送る)
    //window.location.href = "swan/api/line/login";
    window.location.href = "https://miraii-concierge.jp/swan/api/line/login";
  };

  useEffect(() => {
    if (loginApi.state?.status === "success" && loginApi.state.data) {
      navigator("/top");
    }
  }, [loginApi.state?.data]);

  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        <Header hideMenu={true} />
        <div className={styles.title}>ログイン</div>
        <div className={styles.inputArea}>
          <div className={styles.input}>
            <TextForm
              name="email"
              value={formValue.email}
              color="white"
              placeholder="sample@miraii"
              label="メールアドレス"
              inputWidth="100%"
              onChange={handleInputChange}
            ></TextForm>
          </div>
          <div className={styles.input}>
            <TextForm
              name="password"
              value={formValue.password}
              color="white"
              label="パスワード"
              inputWidth="100%"
              type={showPassword ? "text" : "password"}
              rightIcon={showPassword ? iconOpenEye : iconCloseEye}
              onClickRightButton={() => setShowPassword(!showPassword)}
              onChange={handleInputChange}
            ></TextForm>
          </div>
          <div className={styles.buttonArea}>
            <SimpleButton
              label="ログイン"
              width="100%"
              disabled={!canLogin}
              isRadius={true}
              onClick={onLonginClick}
            ></SimpleButton>
          </div>
          <div className={styles.label}>────  または  ────</div>
          <div className={styles.lineButtonArea}>
            <SimpleButton
              label="LINE IDでログイン"
              width="100%"
              isRadius={true}
              color="lightgreen"
              textColor="black"
              leftIcon={lineIcon}
              onClick={onLineLonginClick}
            ></SimpleButton>
          </div>
        </div>
          <div className={styles.marginTop}> </div>
          <div className={styles.link} onClick={() => navigator("/password/reset-request")}>
            パスワードをお忘れの方はこちら
          </div>
          <div className={styles.marginTop}> </div>
          <div className={styles.link} onClick={() => navigator("/registration")}>
            会員登録はこちら
          </div>
      </div>
      <BreadCrumb
        data={[
          { displayName: "みらいいコンシェル", url: "/home" },
          { displayName: "ログイン", url: "/login" },
        ]}
      />
    </div>
  );
};

export default Login;
